module.exports = __webpack_public_path__ + "img/forest.22af203b.svg";